import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { useContent } from '../lib/content';
import { SEO } from '../components/SEO';
import { EnquiryForm } from '../components/EnquiryForm';

export default function Contact() {
  const { contact } = useContent();

  const info = [
    { icon: Phone, label: 'Phone', value: contact.phone },
    { icon: Mail, label: 'Email', value: contact.email },
    { icon: MapPin, label: 'Address', value: contact.address },
    { icon: Clock, label: 'Business Hours', value: contact.hours },
  ];

  return (
    <>
      <SEO
        title="Contact Us"
        description={`Get in touch with Higgins Truck Sales. Call ${contact.phone} or send us a message - we work with customers across Australia.`}
        path="/contact"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-wider text-[#24135F]">GET IN TOUCH</h1>
        <p className="text-[#53565A] mt-2 max-w-xl">
          Have a question about a vehicle or want to discuss your requirements? Fill out the form and we'll get back to
          you as soon as possible.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-10">
          <div className="bg-white border border-[#D9D9D6] rounded-xl p-6 sm:p-8">
            <h2 className="font-heading text-2xl tracking-wider text-[#24135F] mb-5">SEND US A MESSAGE</h2>
            <EnquiryForm />
          </div>

          <div className="space-y-6">
            <div className="bg-white border border-[#D9D9D6] rounded-xl p-6 sm:p-8">
              <h2 className="font-heading text-2xl tracking-wider text-[#24135F] mb-5">CONTACT INFORMATION</h2>
              <ul className="space-y-5">
                {info.map((item) => (
                  <li key={item.label} className="flex items-start gap-4">
                    <span className="h-10 w-10 rounded-full border border-[#E4002B]/40 flex items-center justify-center shrink-0">
                      <item.icon className="h-4 w-4 text-[#E4002B]" />
                    </span>
                    <div>
                      <p className="text-xs font-semibold text-[#53565A]/70 uppercase tracking-wider">{item.label}</p>
                      <p className="text-sm font-medium text-[#24135F] whitespace-pre-line mt-0.5">{item.value}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-[#D9D9D6]/30 border border-[#D9D9D6] rounded-xl h-64 flex flex-col items-center justify-center text-[#53565A]/70">
              <MapPin className="h-10 w-10 text-[#E4002B] mb-2" />
              <p className="text-sm font-medium text-[#53565A] text-center px-4">{contact.address}</p>
              <a
                href={`https://maps.google.com/?q=${encodeURIComponent(contact.address)}`}
                target="_blank"
                rel="noreferrer"
                className="text-xs text-[#E4002B] font-semibold mt-1 hover:underline"
              >
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
